import { FormSkeleton } from '@globaleris/ui.library'
import { List, ListItem, Typography, makeStyles, useTheme } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { EnumDivisa, EnumTipoCalculoConcepto } from '../../../../api'
import { EnumCommodity } from '../../../../api/Argentia/enums'
import { ConceptDetailsModel } from '../../../../api/Argentia/model/contracts'
import { enumEnumToValueString } from '../../../../helpers'
import { styles } from '../concepts.edit.styles'

type ConceptDetailsProps = {
  conceptDetails?: ConceptDetailsModel | null
}

export const ConceptDetails: React.FC<ConceptDetailsProps> = ({ conceptDetails }) => {
  const [t] = useTranslation(['conceptsEdit', 'globalerisLibrary', 'enums'])
  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const classes = useStyles()

  return conceptDetails ? (
    <>
      <Typography variant="h1" color="primary">
        {conceptDetails?.description && conceptDetails.description.length > 25
          ? `${conceptDetails.description.substring(0, 25)}...`
          : conceptDetails?.description}
      </Typography>
      <List className={classes.resume}>
        <ListItem disableGutters>
          <Typography variant={'h2'}>
            {enumEnumToValueString(EnumTipoCalculoConcepto, conceptDetails?.calculationType)}
          </Typography>
        </ListItem>
        <ListItem disableGutters>
          <Typography variant={'body2'}>{conceptDetails?.code}</Typography>
        </ListItem>
        <ListItem divider disableGutters>
          <Typography variant={'caption'}>{t('conceptsEdit:leftColumn.captions.type')}</Typography>
          <Typography variant={'body2'}>{conceptDetails?.conceptTypeLabel}</Typography>
        </ListItem>
        <ListItem divider disableGutters>
          <Typography variant={'caption'}>
            {t('conceptsEdit:leftColumn.captions.currency')}
          </Typography>
          <Typography variant={'body2'}>
            {enumEnumToValueString(EnumDivisa, conceptDetails?.currency)}
          </Typography>
        </ListItem>
        <ListItem divider disableGutters>
          <Typography variant={'caption'}>
            {t('conceptsEdit:leftColumn.captions.commodity')}
          </Typography>
          <Typography variant={'body2'}>
            {enumEnumToValueString(EnumCommodity, conceptDetails?.commodity)}
          </Typography>
        </ListItem>
      </List>
    </>
  ) : (
    <FormSkeleton withTitle={true} elevation={0} columns={1} inputs={9}></FormSkeleton>
  )
}
